import { UserAuthApi } from "@/apis/v2/UserAuthApi";
import { CustomBackdropController } from "@/components/backdrop/default/v1";
import { customToast } from "@/components/toast/custom-react-toastify/v1";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";

const QUERY_KEY = 'UserInfo';

export function useUserInfoQuery({
    isLoggedIn,
    isReady,
    accessToken
}) {
    const queryResult = useQuery({
        queryKey: [QUERY_KEY, accessToken],
        enabled: !!(isLoggedIn && isReady),
        queryFn: async () => {
            const fetchResult = await UserAuthApi.getUserInfo({});

            return fetchResult;
        },
        staleTime: 5000
    });

    useEffect(() => {
        if (queryResult.isLoading) {
            CustomBackdropController().showBackdrop();
        } else {
            CustomBackdropController().hideBackdrop();
        }
    }, [queryResult.isLoading]);

    return queryResult;
}

export function useChangePhoneNumberMutation() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ params, headers, body }) => {

            const response = await UserAuthApi.ChangePhoneNumber({
                headers: headers,
                body: body
            })

            return response;
        },
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
        },
        onError: (error, variables, context) => {
            if (!error) {
                customToast.error('서버와의 연결이 원활하지 않습니다.');
                return;
            }

            let res = error.response;

            customToast.error(res?.data?.message);
        },
        onMutate: async () => {
            CustomBackdropController().showBackdrop();
        },
        onSettled: async () => {
            CustomBackdropController().hideBackdrop();
        }
    });
}